import styled from 'styled-components';
import { formatViewport } from 'utils/get-pixels-to-viewport';
import { overflowScrollAnimation } from 'utils/overflow-scroll-animation';

import { CALENDAR_DESCRIPTION_LINES } from 'components/widgets/widget-calendar/constants';

const DESCRIPTION_LINE_HEIGHT = 20 / 16;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: ${formatViewport(1)} solid ${({ theme }) => theme.border.primary};
  border-radius: 2%;
  overflow: hidden;
`;

export const ImageContainer = styled.div`
  flex: 0 1 70%;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
`;

export const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const InfoContainer = styled.div`
  flex: 0 0 30%;
  display: flex;
  flex-direction: column;
  padding: ${formatViewport(8)} ${formatViewport(16)};
  color: ${({ theme }) => theme.text.primary};
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${formatViewport(10)};
  width: 100%;
`;

export const Title = styled.div<{ $isScrolling: boolean }>`
  flex: 1;
  min-width: 0;
  font-size: ${formatViewport(20)};
  line-height: ${formatViewport(28)};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ${({ $isScrolling }) => ($isScrolling ? 'clip' : 'ellipsis')};
`;

export const TitleText = styled.span<{ $isScrolling: boolean }>`
  display: inline-block;

  ${({ $isScrolling }) => $isScrolling && overflowScrollAnimation('horizontal')}
`;

export const Date = styled.div`
  display: flex;
  flex-shrink: 0;
  white-space: nowrap;
  justify-content: flex-end;
  gap: ${formatViewport(10)};
  font-size: ${formatViewport(16)};
  line-height: ${formatViewport(24)};
  font-weight: 500;
`;

export const DateDivider = styled.div`
  width: ${formatViewport(1)};
  height: 100%;
  background-color: ${({ theme }) => theme.border.primary};
`;

export const BottomRow = styled.div`
  margin-top: ${formatViewport(4)};
  display: grid;
  gap: ${formatViewport(4)};
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 'location capacity' 'description description';
  font-size: ${formatViewport(16)};
  line-height: ${DESCRIPTION_LINE_HEIGHT};
`;

export const IconValueContainer = styled.div<{ $gridArea: string; $multiline?: boolean }>`
  display: flex;
  gap: ${formatViewport(4)};
  align-items: ${({ $multiline }) => ($multiline ? 'flex-start' : 'center')};
  min-width: 0;
  grid-area: ${({ $gridArea }) => $gridArea};

  svg {
    display: flex;
    flex-shrink: 0;
    width: ${formatViewport(16)};
    aspect-ratio: 1;
    height: ${formatViewport(16)};
    margin-top: ${({ $multiline }) => ($multiline ? `${(DESCRIPTION_LINE_HEIGHT - 1) / 2}em` : 0)};
  }

  > span {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const Description = styled.div`
  flex: 1;
  min-width: 0;
  line-height: ${DESCRIPTION_LINE_HEIGHT};
  max-height: ${CALENDAR_DESCRIPTION_LINES * DESCRIPTION_LINE_HEIGHT}em;
  overflow: hidden;
`;

export const DescriptionText = styled.span<{ $isScrolling: boolean }>`
  display: block;
  overflow-wrap: anywhere;

  ${({ $isScrolling }) => $isScrolling && overflowScrollAnimation('vertical')}
`;
